module.exports = __webpack_public_path__ + "static/media/RUR.e8eaae8e.csv";